__turbopack_context__.v({
  "carouselHeader": "tileCarousel-module-scss-module__yRzmvW__carouselHeader",
  "carouselHeaderWrapper": "tileCarousel-module-scss-module__yRzmvW__carouselHeaderWrapper",
  "carouselWrapper": "tileCarousel-module-scss-module__yRzmvW__carouselWrapper",
  "headerButton": "tileCarousel-module-scss-module__yRzmvW__headerButton",
  "itemsWrapper": "tileCarousel-module-scss-module__yRzmvW__itemsWrapper",
  "mobileButton": "tileCarousel-module-scss-module__yRzmvW__mobileButton",
});
